exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".panel{padding:16px;margin-bottom:22px !important}.panel.has-save{padding-bottom:44px}.panel.has-icons{padding-bottom:0}.panel .panel-loader{position:absolute;bottom:0;left:0;right:0}#PanelContainer{position:relative;width:100%;height:100%;z-index:1000}#PanelContainer .scroll-inner{padding:16px 0;padding-right:8px}#PanelContainer .thumb-vertical{background-color:rgba(255,255,255,0.6);cursor:pointer;border-radius:inherit}#PanelContainer .track-vertical{width:8px;right:2px;bottom:2px;top:2px;border-radius:3px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/Panel/style.scss
// module id = 1171
// module chunks = 0